// tslint:disable: naming-convention
import { Action } from '@ngrx/store';
import { ContractStatusEntity } from '../../../entities/mdqx/contract-status.entity';

export enum ContractStatusActionTypes {
    GetContractStatusRequest = '[ContractStatus] Get Request',
    GetContractStatusResponse = '[ContractStatus] Get Response',
}

export class GetContractStatusRequest implements Action {
    readonly type = ContractStatusActionTypes.GetContractStatusRequest;
}

export class GetContractStatusResponse implements Action {
    readonly type = ContractStatusActionTypes.GetContractStatusResponse;
    constructor(public Payload: ContractStatusEntity[]) {}
}

export type ContractStatusActions =
    | GetContractStatusRequest
    | GetContractStatusResponse;
